/**
 * @flow
 * @relayHash 268ecd816d46edc4345dff100c7d45b8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FeeTemplateDeleteMutationVariables = {|
  feeTemplateId: string
|};
export type FeeTemplateDeleteMutationResponse = {|
  +deleteFeeTemplate: ?{|
    +deleted: ?boolean
  |}
|};
export type FeeTemplateDeleteMutation = {|
  variables: FeeTemplateDeleteMutationVariables,
  response: FeeTemplateDeleteMutationResponse,
|};
*/


/*
mutation FeeTemplateDeleteMutation(
  $feeTemplateId: ID!
) {
  deleteFeeTemplate(feeTemplateId: $feeTemplateId) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "feeTemplateId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteFeeTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "feeTemplateId",
        "variableName": "feeTemplateId"
      }
    ],
    "concreteType": "DeleteFeeTemplate",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deleted",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FeeTemplateDeleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FeeTemplateDeleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "FeeTemplateDeleteMutation",
    "id": null,
    "text": "mutation FeeTemplateDeleteMutation(\n  $feeTemplateId: ID!\n) {\n  deleteFeeTemplate(feeTemplateId: $feeTemplateId) {\n    deleted\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab4e139013ecc91ac2dedca56fc709bb';
module.exports = node;
